export const PRE_LOAD_IMGS = [
  // require('@/imgs/index/book/main.jpg'),
];

export const NAV_INFO = [
  {
    name: 'sand',
    width: 33,
    height: 33,
    nWidth: 77,
    nHeight: 54,
    nIcon: require('@/imgs/index/nav/sand_n.png'),
    hIcon: require('@/imgs/index/nav/sand_h.png'),
  },
  {
    name: 'position',
    width: 33,
    height: 33,
    nWidth: 77,
    nHeight: 54,
    nIcon: require('@/imgs/index/nav/position_n.png'),
    hIcon: require('@/imgs/index/nav/position_h.png'),
  },
  {
    name: 'brand',
    width: 33,
    height: 33,
    nWidth: 77,
    nHeight: 54,
    nIcon: require('@/imgs/index/nav/brand_n.png'),
    hIcon: require('@/imgs/index/nav/brand_h.png'),
  },
  {
    name: 'project',
    width: 33,
    height: 33,
    nWidth: 77,
    nHeight: 54,
    nIcon: require('@/imgs/index/nav/project_n.png'),
    hIcon: require('@/imgs/index/nav/project_h.png'),
  },
  {
    name: 'house',
    width: 33,
    height: 33,
    nWidth: 77,
    nHeight: 54,
    nIcon: require('@/imgs/index/nav/house_n.png'),
    hIcon: require('@/imgs/index/nav/house_h.png'),
  },
  {
    name: 'house_tour',
    width: 33,
    height: 33,
    nWidth: 77,
    nHeight: 54,
    nIcon: require('@/imgs/index/nav/house_tour_n.png'),
    hIcon: require('@/imgs/index/nav/house_tour_h.png'),
  },
  {
    name: 'park',
    width: 33,
    height: 33,
    nWidth: 77,
    nHeight: 54,
    nIcon: require('@/imgs/index/nav/park_n.png'),
    hIcon: require('@/imgs/index/nav/park_h.png'),
  },
  {
    name: 'park_p',
    width: 33,
    height: 33,
    nWidth: 77,
    nHeight: 54,
    nIcon: require('@/imgs/index/nav/park_p_n.png'),
    hIcon: require('@/imgs/index/nav/park_p_h.png'),
  },
  {
    name: 'book',
    width: 33,
    height: 33,
    nWidth: 77,
    nHeight: 54,
    nIcon: require('@/imgs/index/nav/book_n.png'),
    hIcon: require('@/imgs/index/nav/book_h.png'),
  },
];
export const CONTACTS_INFO = [
  // {
  //   title: '销售经理',
  //   name: '',
  //   company: '',
  //   img: require('@/imgs/contacts/01.jpg'),
  //   phone: '',
  // },
];
export const DISCLAIMER_TEXT = '项目最终呈现效果存在一定差异，仅供参考，不作为开发商的任何要约或承诺。';
